"use client";

import { useState, useEffect } from "react";

export function MobileMenuButton({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleNav = () => setOpen(false);
    window.addEventListener("popstate", handleNav);
    const observer = new MutationObserver(handleNav);
    const title = document.querySelector("title");
    if (title) {
      observer.observe(title, { childList: true });
    }
    return () => {
      window.removeEventListener("popstate", handleNav);
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="min-[812px]:hidden flex flex-col justify-center items-center w-9 h-9 gap-[5px] rounded"
        aria-label="Toggle menu"
      >
        <span className={`block w-5 h-[2px] bg-white transition-all duration-200 ${open ? "rotate-45 translate-y-[7px]" : ""}`} />
        <span className={`block w-5 h-[2px] bg-white transition-all duration-200 ${open ? "opacity-0" : ""}`} />
        <span className={`block w-5 h-[2px] bg-white transition-all duration-200 ${open ? "-rotate-45 -translate-y-[7px]" : ""}`} />
      </button>

      {open && (
        <div className="min-[812px]:hidden absolute top-[calc(100%+4px)] left-0 right-0 mx-auto bg-white/95 backdrop-blur-xl border border-liberty-blue/10 shadow-[0_8px_32px_rgba(0,0,0,0.15)] rounded-2xl z-50 overflow-hidden">
          <nav
            className="flex flex-col px-5 py-4 gap-3 text-base font-medium text-bunting-navy"
            onClick={() => setOpen(false)}
          >
            {children}
          </nav>
        </div>
      )}
    </>
  );
}
